import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { useTranslation } from 'react-i18next';
import { NAV_SECTIONS } from '@/components/nav/nav-config';

/** Routes that exist outside the rail nav (deep-linked from top bar etc). */
const EXTRA_TITLES: Record<string, string> = {
  '/notices': 'nav.notices',
};

/** Resolve current page title from nav-config or extra map. */
export function useRouteTitle(): string {
  const { t } = useTranslation();
  const { pathname } = useLocation();

  return useMemo(() => {
    for (const section of NAV_SECTIONS) {
      for (const item of section.items) {
        if (item.path === pathname) return t(item.labelKey);
      }
    }
    const extra = EXTRA_TITLES[pathname];
    if (extra) return t(extra);
    return t('nav.home');
  }, [pathname, t]);
}
